import { render } from "./TextArea.vue?vue&type=template&id=4b7a3006&scoped=true"
import script from "./TextArea.vue?vue&type=script&lang=js"
export * from "./TextArea.vue?vue&type=script&lang=js"

import "./TextArea.vue?vue&type=style&index=0&id=4b7a3006&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4b7a3006"

export default script